<div class="container">
  <div class="title-container">
    <ion-label class="title" data-cy="chef-store-qr-code-component-title">{{
      'i18n.more.chefStore' | translate
    }}</ion-label>
    <p class="description" data-cy="chef-store-qr-code-component-description">
      {{ 'i18n.more.chefStoreDescription' | translate }}
    </p>
  </div>
  <div class="qr-container">
    <qrcode
      *ngIf="this.qrCode"
      class="qr-code"
      data-cy="chef-store-qr-code-component-qr-code"
      [qrdata]="this.qrCode"
      [width]="this.qrCodeWidth"
      [errorCorrectionLevel]="'M'"
      [margin]="1.5"
    >
    </qrcode>
  </div>
  <div class="footer">
    <ion-label
      class="footer-description"
      data-cy="chef-store-qr-code-component-footer-description"
      >{{ 'i18n.more.chefStoreFooter' | translate }}</ion-label
    >
    <p>
      <a
        (click)="
          this.routeTo(
            'https://www.usfoods.com/content/dam/usf/EC/R4/documents/index.html'
          )
        "
        >{{ 'i18n.more.chefStoreTerms' | translate }}</a
      >
      {{ 'i18n.more.chefStoreAnd' | translate }}
      <a
        (click)="
          this.routeTo(
            'https://www.usfoods.com/content/dam/usf/EC/R4/documents/privacy.html'
          )
        "
        >{{ 'i18n.more.chefStorePolicy' | translate }}</a
      >
    </p>
  </div>
  <div class="button-container">
    <ion-button
      class="usf-fill-green-button cancel-button"
      (click)="cancel()"
      data-cy="chef-store-qr-code-component-cancel-button"
    >
      {{ 'i18n.more.chefStoreCancel' | translate }}
    </ion-button>
  </div>
</div>
